import { REACT_ROOT_MAIN } from '@app/constants/targets';
import { lazy } from 'react';
import { createPortal } from 'react-dom';
import '@app/special-characters-support.scss';

const HomePage = lazy(() => import('./HomePage'));

const Container = () => {
  const homepageTarget = document.getElementById(REACT_ROOT_MAIN);
  return homepageTarget ? createPortal(<HomePage />, homepageTarget) : null;
};

export default Container;
